
import CookieDialog from './CookieDialog.vue'

export default {
  name: 'CookieBanner',

  components: {
    CookieDialog,
  },

  data: () => ({
    show_banner: false,
    show_popup: false,
  }),

  computed: {
    imageHeight() {
      switch (
        this.$vuetify.breakpoint.name
      ) {
        case 'xs':
          return '200px'

        case 'sm':
          return '400px'

        case 'md':
          return '600px'

        case 'lg':
          return '800px'

        case 'xl':
          return '1000px'

        default:
          return '0px'
      }
    },
  },

  mounted() {
    /*
     * If Remember Me has never been configured, show the
     * first-visit cookie banner.
     *
     * A value of "0" still means the preference has been set,
     * so Reject All does not cause the banner to return.
     */
    const cookie =
      this.$cookies.get(
        'remember-me',
        {
          parseJSON: false,
        }
      )

    if (
      cookie === undefined ||
      cookie === null ||
      cookie === ''
    ) {
      this.show_banner = true
      this.show_popup = false

      return
    }

    /*
     * Preferences already exist.
     * Show only the small cookie-settings launcher.
     */
    this.show_banner = false
    this.show_popup = true
  },

  methods: {
    /**
     * Open the detailed preference dialog.
     *
     * Hide the fixed banner immediately so it cannot remain as
     * an invisible layer over the CAPTCHA or Begin button.
     */
    async manageCookies() {
      this.show_banner = false
      this.show_popup = true

      await this.$nextTick()

      if (
        this.$refs.dialog &&
        typeof this.$refs.dialog.openDialog ===
          'function'
      ) {
        this.$refs.dialog.openDialog()
      }
    },

    /**
     * Accept all optional cookies.
     *
     * Reload after both preferences have been saved. This lets
     * index.vue, Vuex persistence and Analytics initialise from
     * one consistent cookie state.
     */
    async acceptAll() {
      await this.setCookies(
        1,
        1
      )

      if (
        process.client &&
        typeof window !== 'undefined'
      ) {
        window.location.reload()
      }
    },

    /**
     * Reject optional cookies.
     *
     * No reload is required. Simply remove the banner completely
     * and expose the normal cookie-settings launcher.
     */
    async rejectAll() {
      await this.setCookies(
        0,
        0
      )

      this.show_banner = false
      this.show_popup = true
    },

    closePopOut() {
      this.show_popup = false
    },

    /**
     * Persist both preference categories.
     */
    async setCookies(
      session,
      analytics
    ) {
      await this.$store.dispatch(
        'auth/setGAPreference',
        analytics
      )

      await this.$store.dispatch(
        'auth/setRememberMePreference',
        session
      )
    },
  },
}
